import { handleSignOut } from "../../common/handleSignOut";
import styles from "./AuthenticationError.module.scss";
import { CommonAuthenticationError } from "./CommonAuthenticationError";
import { UserAlreadyMappedError } from "./UserAlreadyMappedError";
import { ExternalUserAlreadyMappedError } from "./ExternalUserAlreadyMappedError";

export interface AuthenticationErrorProps {
  onLogout: () => void;
}

export const AuthenticationError = (props: { errorMessage: any }) => {
  const logOut = () => {
    handleSignOut({ reason: "Authentication error", url: window.location.href })
  };
 
  if (props.errorMessage == 'ExternalUser_Already_Mapped') {
    return (
      
      <ExternalUserAlreadyMappedError />
    )
  } else if (props.errorMessage == 'User_Already_Mapped') {
    return (
      <UserAlreadyMappedError />
    )
  } else {
    return (
      <CommonAuthenticationError />
    )
  }
};
